import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import enumsSlice from './store/enums/EnumsSlice';
import { EnumService } from './api/services/EnumService';
import { UserService } from './app/user/UserService';
import { ErrorToast } from './utils/toasters';
import ModalConfirm from './shared/components/modal/ModalConfirm';
import ModalVersion from './shared/components/modal/ModalVersion';
import AppIndex from './app/app-index';

export default function App() {
    const dispatch = useDispatch();
    const token = localStorage.getItem('token');

    useEffect(() => {
        if (token) {
            UserService.getPersonalInfo({ token: token ?? '' })
                .then(data => {
                    localStorage.setItem('adminAcl', String(data?.adminAcl));
                })
                .catch(error => ErrorToast(error));
        }
    }, []);

    useEffect(() => {
        EnumService.getEnums().then(data => {
            dispatch(enumsSlice.actions.setEnums(data));
        });
    }, []);

    return (
        <BrowserRouter>
            <AppIndex />
            <ToastContainer />
            <ModalConfirm />
            <ModalVersion />
        </BrowserRouter>
    );
}
